import { Directive, forwardRef, Renderer2, ElementRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

const TIME_INPUT_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => TimeInputDirective),
    multi: true
};

@Directive({
    selector: '[time-input]',
    host: {
        '(input)': 'onInput($event.target.value)',
        '(blur)': 'onBlur()'
    },
    providers: [TIME_INPUT_VALUE_ACCESSOR]
})
export class TimeInputDirective implements ControlValueAccessor {

    private readonly validChars = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];

    constructor(private renderer: Renderer2, private elementRef: ElementRef) {
    }

    public onChange = (_: any) => {};

    public onTouched = () => {};

    public registerOnChange(fn: (value: any) => any): void {
        this.onChange = fn;
    }

    public registerOnTouched(fn: () => any): void {
        this.onTouched = fn;
    }

    public onBlur() {
        this.onTouched();
    }

    public onInput(value: string) {
        const formatted: any = this.formatValue(value);
        this.renderer.setProperty(this.elementRef.nativeElement, 'value', formatted);
        this.onChange(formatted);
    }

    public writeValue(value: any): void {
        const formatted: any = this.formatValue(value);
        this.renderer.setProperty(this.elementRef.nativeElement, 'value', formatted);
    }

    private formatValue(value: any): string {
        return value && typeof value === 'string' ?
            this.validateChars(value) :
            '';
    }

    private validateChars(input: string): string {
        const inputValue = input.split('');

        for (let i = (inputValue.length - 1); i > -1; i--) {
            const val = inputValue[i];

            if (this.validChars.indexOf(val) === -1) {
                inputValue.splice(i, 1);
            } else {
                if ((i === 0 && !this.validateNotLargerThan(val, 2)) || // The first character can not be bigger than 2
                    (i === 1 && inputValue[0] === '2' && !this.validateNotLargerThan(val, 3)) || // If the first char is 2 then the second char cannot be bigger than 3
                    (i === 2 && !this.validateNotLargerThan(val, 5))) { // The third character can not be bigger than 6
                    inputValue.splice(i, 1);
                }
            }
        }

        if (inputValue.length > 4) {
            inputValue.splice(3, inputValue.length - 4);
        }

        if (inputValue.length === 4) {
            inputValue.splice(2, 0, ':');
        }

        return inputValue.join('');
    }

    private validateNotLargerThan(val: string, noLargerThan: number): boolean {
        const asNumber = Number(val);
        return asNumber <= noLargerThan;
    }
}
